import React from "react";
const ParentSheetContext = React.createContext({
    zIndex: 1e5
  }),
  SheetInsideSheetContext = React.createContext(null);
export { ParentSheetContext, SheetInsideSheetContext };
//# sourceMappingURL=contexts.mjs.map
